import React, { useEffect, useState } from "react"
import DataFilterListItem from "./DataFilterListItem"

const DataFilterList = ({ items, setSelectedItems, selectedItems }) => {
    const handleItemClick = (item) => {
        if (!items) return
        const newItems = selectedItems.includes(item)
            ? selectedItems.filter((i) => i !== item)
            : [...selectedItems, item]
        setSelectedItems(newItems)
    }

    return (
        <ul className="w-full flex flex-wrap gap-1">
            {items &&
                items.map((item, index) => (
                    <DataFilterListItem
                        key={index}
                        item={item}
                        onClick={handleItemClick}
                        checked={selectedItems.includes(item)}
                        isLastItem={items.length - 1 === index}
                    />
                ))}
        </ul>
    )
}

export default DataFilterList
